// DeleteConfirmDialog.jsx - Conferma Eliminazione
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const DeleteConfirmDialog = ({ open, onClose, onConfirm, t }) => {
  
  const handleConfirm = async () => {
    try {
      await onConfirm();
    } catch (error) {
      // L'errore è già gestito nel componente padre
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1,
        color: '#d32f2f' 
      }}>
        <WarningIcon color="error" />
        {t("confirmDelete") || "Conferma Eliminazione"}
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body1">
            Sei sicuro di voler eliminare questo corso di formazione?
          </Typography>
        </Alert>
        
        <Typography variant="body2" color="text.secondary">
          Questa azione non può essere annullata. Tutti i dati associati al corso, 
          incluse le iscrizioni e le presenze, verranno eliminati definitivamente.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined">
          {t("cancel") || "Annulla"}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          sx={{ ml: 1 }}
        >
          {t("delete") || "Elimina"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog;